{
	"hero": {
		"tag": "Frisbeegolf-markkinapaikka",
		"heading_1": "SEURAAVA",
		"heading_2": "HEITTOSI",
		"heading_3": "ALKAA",
		"heading_4": "TÄÄLTÄ.",
		"body": "Selaa pelaajien myynti-ilmoituksia alueellasi. Ota suoraan yhteyttä myyjään — ilmainen myyntilistaus, ei välityspalkkioita.",
		"cta_browse": "Selaa ilmoituksia",
		"cta_sell": "Myy kiekko",
		"free_note": "Ilmainen — ei välikäsiä, ei välityspalkkioita"
	},
	"stats": {
		"activeListings_label": "Aktiiviset ilmoitukset",
		"activeListings_sub": "frisbeegolf-kiekkoa myynnissä",
		"sellers_label": "Myyjät",
		"sellers_sub": "pelaajaa yhteisössä",
		"free_value": "Ilmainen",
		"free_label": "Aloittamiseen",
		"free_sub": "lisäpalveluja saatavilla"
	},
	"discTypes": {
		"tag": "Tutustu",
		"heading": "Selaa kiekkotyypeittäin",
		"cta": "Selaa →",
		"distanceDrivers": "Distanse-kiekot",
		"fairwayDrivers": "Fairway-kiekot",
		"midranges": "Midranget",
		"putters": "Putterit"
	},
	"howItWorks": {
		"tag": "Yksinkertainen prosessi",
		"heading": "Miten se toimii",
		"step1": {
			"n": "Vaihe 1",
			"title": "Selaa ilmoituksia",
			"body": "Suodata kiekkomallin, merkin, kunnon, painon ja lentoparametrien mukaan. Kaikki tarvitsemasi tiedot ovat näkyvissä."
		},
		"step2": {
			"n": "Vaihe 2",
			"title": "Lähetä viesti myyjälle",
			"body": "Käytä sisäänrakennettua chattiä viestiäksesi myyjälle suoraan ilmoituksesta. Yhteystietoja ei tarvitse jakaa — kaikki pysyy yhdessä paikassa."
		},
		"step3": {
			"n": "Vaihe 3",
			"title": "Tee kaupat omalla tavallasi",
			"body": "Sovi hinnasta, tapaa tai järjestä toimitus. Re:Disc ei koskaan puutu kauppaan — ei välityspalkkioita."
		}
	},
	"featured": {
		"tag": "Tuoreimmat",
		"heading": "Uusimmat ilmoitukset",
		"viewAll": "Näytä kaikki →",
		"empty": "Ei vielä ilmoituksia. Ole ensimmäinen myyjä!"
	},
	"support": {
		"tag": "Yhden hengen projekti",
		"heading_1": "YKSIN TEHTY.",
		"heading_2_accent": "ILMAISEKSI",
		"heading_2_suffix": " SINULLE.",
		"body": "Re:Discissä ei ole mainoksia, listausmaksuja eikä sijoittajia. Vain yksi kehittäjä rakentamassa frisbeegolfyhteisöä varten. Jos sovellus on ollut hyödyllinen, kahvitarjouksesi pitää sen hengissä.",
		"cta": "Osta minulle kahvi",
		"sub": "MobilePaylla · täysin vapaaehtoinen"
	},
	"sellCta": {
		"tag": "Ilmainen aloitus",
		"heading_1": "ONKO SINULLA",
		"heading_2_prefix": "KIEKKOJA ",
		"heading_2_accent": "MYYTÄVÄNÄ?",
		"body": "Listaa kiekkosi minuuteissa. Re:Disc yhdistää sinut oikean ostajan kanssa — ilmainen aloitus, ei välityspalkkioita.",
		"cta_create": "Luo ilmoitus",
		"cta_how": "Katso miten se toimii",
		"activeListings_label": "Aktiiviset ilmoitukset"
	}
}
